@if (showIcon() && iconClass()) {
    <i class="status-badge__icon" [class]="iconClass()" aria-hidden="true" [style.font-size.px]="iconSize()"></i>
}
@if (showText() && (label() || resolvedTranslationKey())) {
    <span class="status-badge__label">
        @if (label()) {
            {{ label() }}
        } @else {
            {{ resolvedTranslationKey()! | transloco }}
        }
    </span>
}
@if (hasTooltip()) {
    <dx-tooltip [target]="tooltipTarget" style="position: absolute">
        <div *dxTemplate="let data of 'content'">
            @if (tooltip()) {
                {{ tooltip() }}
            } @else if (tooltipTranslationKey()) {
                {{ tooltipTranslationKey()! | transloco }}
            } @else if (label()) {
                {{ label() }}
            } @else {
                {{ resolvedTranslationKey()! | transloco }}
            }
        </div>
    </dx-tooltip>
}
